import { useDispatch, useSelector } from "react-redux"
import CustomAxios from "../utils/CustomAxios"
import { updateFoodfixCutoffTime, updateLoading, updateOrderDetails, updateOrderModel, updateOrders, updatePartnerAssignModal, updateUpdatedDate, updateassignedOrders, updatecompletedOrders, updatefilteredOrders, updatependingOrders, updateselectedDeliveryPartner } from "../Redux/orders"
import { updateLoadingProducts, updateProducts } from "../Redux/products";
import { updateLoadingCampaigns, updateCampaigns, updateActiveStatus, updateExpiredCampaigns, updateUpcomingCampaigns } from "../Redux/campaign";
import { updateLoadingCategories, updateCategories } from "../Redux/category-redux";
import { updateSubCategories, updateLoadingSubCategories } from "../Redux/sub-category-redux";
import { updateBatchHistory, updateInventory, updateInventoryDetail, updateInventoryDetailsLoading, updateInventoryDetailsModal, updateInventoryLoading, updateInventoryModal, updateInventoryform, updateInventryHubsupervisors, updateSelectedBatchNo, updateallInventryDetails, updateinventoryDetailsEdit } from "../Redux/inventory";
import dayjs from "dayjs";
import { Box, Button, InputBase, MenuItem, Modal, Select, Tooltip, Typography, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel } from "@mui/material";
import { useMemo, useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Toast } from 'primereact/toast';
import { OrderProductsTable } from "../sub_components/ordered_products_table";
import CustomAxiosDP from "../utils/CustomAxiosDP";
import { format } from 'date-fns';
import CircularProgress from '@mui/material/CircularProgress';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AutoComplete } from "primereact/autocomplete";
import { updateOfferLoading, updateOffers } from "../Redux/offers";
import { updateSettings } from "../Redux/settings";
import { updateorderRefresh } from "../Redux/orders";
import { updateProductBanners} from "../Redux/product-banner";
import { updateInstructions, updateLoadingInstruction } from "../Redux/add-instruction";
import { updateHomeBanners } from "../Redux/home_banner";

const getDeliveryAddressMapCoords = (deliveryAddress) => {
    if (!deliveryAddress) return null;
    const lat = Number(deliveryAddress.latitude ?? deliveryAddress.lattitude);
    const lng = Number(deliveryAddress.longitude ?? deliveryAddress.longitute);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    return { lat, lng };
};

const getDeliveryAddressMapUrl = (deliveryAddress) => {
    const coords = getDeliveryAddressMapCoords(deliveryAddress);
    if (!coords) return null;
    return `https://www.google.com/maps/search/?api=1&query=${coords.lat},${coords.lng}`;
};

const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;

export const DeliveryLocationMap = ({ deliveryAddress, height = 180 }) => {
    const coords = getDeliveryAddressMapCoords(deliveryAddress);
    if (!coords || !GOOGLE_MAPS_KEY) return null;
    return (
        <Box sx={{ width: "100%", height, mt: 1, borderRadius: "6px", overflow: "hidden", border: "1px solid #E5E7EB" }}>
            <iframe
                title="Delivery location"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_KEY}&q=${coords.lat},${coords.lng}&zoom=16`}
            />
        </Box>
    );
};

const openDeliveryAddressInMap = (deliveryAddress) => {
    const url = getDeliveryAddressMapUrl(deliveryAddress);
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
};

export const useGetOrders = () => {
    const dispatch = useDispatch();
    const today = dayjs()
    const formatdate = useDateformate()

    const getOrders = async () => {
        // dispatch(updateLoading(true))
        try {
            const response = await CustomAxios.get(`get_all_orders/`);

            // Filter orders based on payment_status === true
            const validOrders = response.data.filter((order) => order.payment_status === true)

            dispatch(updateOrders(validOrders))
            // dispatch(updateLoading(false))

            if (validOrders.length > 0) {

                const pendingOrders = validOrders.filter(
                    (item) =>
                        item.status === "pending" &&
                        formatdate(item.created_on) === today.format("DD-MM-YYYY")
                )
                const assignedOrders = validOrders.filter((item) => item.status === "delivery_partner_assigned")
                const completedOrders = validOrders.filter((item) => item.status === "delivered")


                dispatch(updatependingOrders(pendingOrders))
                dispatch(updateassignedOrders(assignedOrders))
                dispatch(updatecompletedOrders(completedOrders))
            } else {

                dispatch(updatependingOrders(0))
                dispatch(updateassignedOrders(0))
                dispatch(updatecompletedOrders(0))
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
            // dispatch(updateLoading(false))
        }
    };

    return getOrders;
};




export const useGetProducts = () => {
    const dispatch = useDispatch();
    const hubFromStore = useSelector(state => state.user.selected_hub);

    const getDetails = async () => {
        let selectedHub = null;

        // Try Redux first
        if (hubFromStore !== null && !isNaN(hubFromStore)) {
            selectedHub = hubFromStore;
        }

        // Fallback to localStorage if needed
        if (!selectedHub) {
            const stored = localStorage.getItem("selected_hub");
            const parsed = parseInt(stored, 10);
            if (!isNaN(parsed)) {
                selectedHub = parsed;
            }
        }

        if (!selectedHub || isNaN(selectedHub)) {
            console.warn("No valid selected hub. Skipping product fetch.");
            return;
        }

        try {
            dispatch(updateLoadingProducts(true));

            const response = await CustomAxios.get(`/products/?group_by=inventory`);

            const options = response?.data?.map((item) => ({
                name: item.item_name,
                value: item.id,
                image: item.image_urls?.[0],
                ...item,
            }));

            dispatch(updateProducts(options));
        } catch (error) {
            console.error("Error fetching products:", error);
        } finally {
            dispatch(updateLoadingProducts(false));
        }
    };

    return getDetails;
};



export const useGetCampaign = () => {
    const hub = useSelector(state => state.user.selected_hub);
    const dispatch = useDispatch();
    
    const getCampaignDetails = async () => {
        dispatch(updateLoadingCampaigns(true));
        const selectedHubRaw = localStorage.getItem('selected_hub');
        let selectedHub;
        try {
            const parsed = JSON.parse(selectedHubRaw || '[]');
            if (Array.isArray(parsed) && parsed.length > 0) {
                selectedHub = parsed[0];
            } else {
                selectedHub = parsed;
            }
        } catch (error) {
            selectedHub = selectedHubRaw;
        }

        try {
            const response = await CustomAxios.get(`campaigns/?hub_id=${selectedHub}`);
            const options = response?.data?.map((item) => ({
                description: item.description,
                launch_date: item.launch_date,
                end_date: item.end_date,
                status: item.status,
                images: item.campaign_image_urls,
                ...item
            }));

            const currentDate = new Date();

            const activeStatus = options.filter(
                (item) => item.status === "active"
            );

            const upcomingCampaigns = options.filter(
                (item) =>
                    new Date(item.launch_date) > currentDate &&
                    item.status === "active"
            );

            const expiredCampaigns = options.filter(
                (item) => new Date(item.end_date) < currentDate
            );

            dispatch(updateActiveStatus(activeStatus));
            dispatch(updateUpcomingCampaigns(upcomingCampaigns)); // Dispatch upcoming campaigns
            dispatch(updateExpiredCampaigns(expiredCampaigns)); // Dispatch expired campaigns
            dispatch(updateCampaigns(options));
            dispatch(updateLoadingCampaigns(false));
        } catch (error) {
            console.error("Error fetching campaigns:", error);
            dispatch(updateLoadingCampaigns(false));
        }
    };

    return getCampaignDetails;
};

export const useGetCategories = () => {
    const dispatch = useDispatch();
    const hub = useSelector(state => state.user.selected_hub);
    
    const getCategoryDetails = async () => {
        dispatch(updateLoadingCategories(true)); // Update the loading state for campaigns
        const selectedHubRaw = localStorage.getItem('selected_hub');
        const userRole = localStorage.getItem('role');
        
        let selectedHub;
        try {
            const parsedHub = JSON.parse(selectedHubRaw || '[]');
            
            if (userRole === 'super_admin') {
                selectedHub = 'all';
            } else if (Array.isArray(parsedHub) && parsedHub.length > 0) {
                selectedHub = parsedHub[0];
            } else {
                selectedHub = parsedHub;
            }
        } catch (error) {
            selectedHub = selectedHubRaw;
        }
        
        try {
            const response = await CustomAxios.get(`category/${selectedHub}/?role=${userRole}`);
            const options = response?.data?.map((item) => ({
                category_name: item.category_name,
                category_image: item.camtegory_image_urls,
                invetory_list: item.invetory_list,
                ...item
            }));

            dispatch(updateCategories(options));
            dispatch(updateLoadingCategories(false));
        } catch (error) {
            console.error("Error fetching campaigns:", error);
            dispatch(updateLoadingCategories(false));
        }
    };

    return getCategoryDetails;
};

export const useGetSubCategories = () => {
    const dispatch = useDispatch();
    
    const getSubCategoryDetails = async () => {
        dispatch(updateLoadingSubCategories(true)); // Update the loading state for campaigns
        try {
            const response = await CustomAxios.get(`sub_category/`);
            const options = response?.data?.map((item) => ({
                subcategory_name: item.subcategory_name,
                sub_category_image: item.sub_category_image,
                category_id: item.category_id,
                ...item
            }));

            dispatch(updateSubCategories(options));
            dispatch(updateLoadingSubCategories(false));
        } catch (error) {
            console.error("Error fetching campaigns:", error);
            dispatch(updateLoadingCategories(false));
        }
    };

    return getSubCategoryDetails;
};

export const useGetInstructions = () => {
  const dispatch = useDispatch();

  const getInstructionDetails = async () => {
    dispatch(updateLoadingInstruction(true));
    try {
      const { data } = await CustomAxios.get("instructions/");
      dispatch(updateInstructions(Array.isArray(data) ? data : []));
    } catch (error) {
      console.error("Error fetching instructions:", error);
      dispatch(updateInstructions([]));
    } finally {
      dispatch(updateLoadingInstruction(false));
    }
  };

  return getInstructionDetails;
};


export const useGetInventory = () => {
    const dispatch = useDispatch();
    
    const getInventerory = async () => {
        dispatch(updateInventoryLoading(true))
        try {
            const inventory = await CustomAxios.get(`inventory/view`, {
            }).then(res => {
                console.log(res)
                const options = res?.data?.map((item) => ({
                    name: item.place,
                    value: item.id,
                    supervisors: item.supervisors,
                    admins: item.admins, 
                    customer_engagement_admins: item.customer_engagement_admins,
                    cashier_ids: item.cashier_ids || [],
                    pincodes: item.pincodes,
                    franchise: item.franchise, // Add franchise information
                    delivery_fee: item.delivery_fee,
                    self_pickup_waiver: item.self_pickup_waiver,
                    self_pickup_waiver_percentage: item.self_pickup_waiver_percentage,
                    mobileno: item.mobileno,
                    delivery_status : item.delivery_status,
                    delivery_mini_spent: item.delivery_mini_spent,
                    shop_open_at: item.shop_open_at,
                    shop_close_at: item.shop_close_at,
                    // The customer-facing delivery promise. Kept as ?? '' rather
                    // than || '' so a deliberate 0 is not silently dropped.
                    is_accepting_orders: item.is_accepting_orders !== false,
                    promised_delivery_min_minutes: item.promised_delivery_min_minutes ?? '',
                    promised_delivery_max_minutes: item.promised_delivery_max_minutes ?? '',
                    hub_setup: item.hub_setup,
                    signup_offer_status: item.signup_offer_status || false
                }));
                dispatch(updateInventoryform({
                    place: '',
                    supervisor_ids: [],
                    cashier_ids: []
                },))
                dispatch(updateInventoryModal(false))
                options && dispatch(updateInventory(options))
            })
        }
        catch (error) {
            console.error("Error fetching orders:", error);
            dispatch(updateInventoryLoading(false))
        }
    }

    return getInventerory;
};

export const useGetInventoryDetails = () => {
    const dispatch = useDispatch();
    const hubFromStore = useSelector(state => state.user.selected_hub);

    let selectedHub = null;

    // Try to get from Redux store
    if (hubFromStore !== null && !isNaN(hubFromStore)) {
        selectedHub = hubFromStore;
    }

    // If not in Redux, fallback to localStorage
    if (!selectedHub) {
        const storedSelectedHub = localStorage.getItem("selected_hub");
        const parsed = parseInt(storedSelectedHub, 10);
        if (!isNaN(parsed)) {
            selectedHub = parsed;
        }
    }

    const getInventeroryDetails = async () => {
        if (!selectedHub) {
            console.log("No selected hub found, skipping inventory details fetch");
            return;
        }

        dispatch(updateInventoryDetailsLoading(true));

        try {
            const res = await CustomAxios.get(`inventory/details/view/${selectedHub}/`);
            const options = res?.data?.map((item) => ({
                ...item,
                details_id: item.details,
            }));
            dispatch(updateallInventryDetails(options));
            dispatch(updateInventoryDetailsModal(false));
        } catch (error) {
            console.error("Error fetching inventory details:", error);
        } finally {
            dispatch(updateInventoryDetailsLoading(false));
        }
    };

    useEffect(() => {
        if (selectedHub) {
            getInventeroryDetails();
        }
    }, [hubFromStore]);

    return getInventeroryDetails;
};


export const useFetchOrders = () => {
    const dispatch = useDispatch();
    const actorders = useSelector(state => state.orders.orders);
    const hub_ID = useSelector(state => state.user.selected_hub);
    const formatDate = useDateformate();


    const orderrefresh=useSelector(state=>state.orders.ordersRefresh)
    useEffect(()=>{
        if (orderrefresh){
            fetchOrders(new Date(), new Date(),false)
        }
        
    },[orderrefresh])
    const fetchOrders = async (start, end, deliverypartner) => {
        const selectedHubRaw = localStorage.getItem('selected_hub');
        const userRole = localStorage.getItem('role');
        
        try {
            dispatch(updateLoading(true))
            dispatch(updateOrders([]))
 
            let response;
            let fOrders;
            const selectedFranchiseIdRaw = localStorage.getItem('selected_franchise_id');
            const selectedFranchiseId = selectedFranchiseIdRaw ? parseInt(selectedFranchiseIdRaw, 10) : null;
            const isFoodfix = selectedFranchiseId === 2;

            if (userRole === 'super_admin') {
                let selectedHubForAdmin;
                try {
                    const parsedHub = JSON.parse(selectedHubRaw || '[]');
                    if (Array.isArray(parsedHub) && parsedHub.length > 0) {
                        selectedHubForAdmin = parsedHub[0];
                    } else {
                        selectedHubForAdmin = parsedHub;
                    }
                } catch (error) {
                    selectedHubForAdmin = selectedHubRaw;
                }

                if (selectedHubForAdmin) {
                     // Hub selected: fetch orders for that hub within date range
                     const params = {
                        start: dayjs(start).format('DD-MM-YYYY'),
                        end: dayjs(end).format('DD-MM-YYYY'),
                    };
                    if (isFoodfix) {
                        params.time = '17:30';
                    }
                    response = await CustomAxios.get(`get_orders_date/${selectedHubForAdmin}/`, { params });
                    fOrders = response?.data;
                } else {
                    const allOrdersResponse = await CustomAxios.get(`get_all_orders/`);
                    const allOrders = allOrdersResponse.data;
                    const startDate = dayjs(start).startOf('day');
                    const endDate = dayjs(end).endOf('day');
                    const filteredOrders = allOrders.filter(order => {
                        const orderDate = dayjs(order.created_on);
                        return orderDate.isAfter(startDate) && orderDate.isBefore(endDate);
                    });

                    fOrders = {
                        current_orders: filteredOrders.filter(order =>
                            !['delivered', 'cancelled', 'declined', 'picked'].includes(order.status) && order.payment_status === true
                        ),
                        history_orders: filteredOrders.filter(order =>
                            ['delivered', 'cancelled', 'declined', 'picked'].includes(order.status) && order.payment_status === true
                        )
                    };
                }
            } else {
                // Other roles use inventory-specific endpoint
                let selectedHub;
                try {
                    const parsedHub = JSON.parse(selectedHubRaw || '[]');
                    if (Array.isArray(parsedHub) && parsedHub.length > 0) {
                        selectedHub = parsedHub[0];
                    } else {
                        selectedHub = parsedHub;
                    }
                } catch (error) {
                    selectedHub = selectedHubRaw;
                }

                const params = {
                    start: dayjs(start).format('DD-MM-YYYY'),
                    end: dayjs(end).format('DD-MM-YYYY'),
                };
                if (isFoodfix) {
                    params.time = '17:30'; // fetch orders from previous day 5:30 PM only for Foodfix
                }
                response = await CustomAxios.get(`get_orders_date/${selectedHub}/`, { params });
                fOrders = response?.data;
            }

            const cutoffTimeFromResponse = fOrders?.foodfix_cutoff_time ?? null;
            console.log("cutoffTimeFromResponse ---------------->>>>>>>>>>", cutoffTimeFromResponse);
            
            dispatch(updateFoodfixCutoffTime(cutoffTimeFromResponse));

            let allOrders = [];
            if (fOrders?.current_orders) {
                allOrders = [...fOrders?.current_orders];
            }
            if (fOrders?.history_orders) {
                allOrders = [...allOrders, ...fOrders?.history_orders];
            }

            // Apply delivery partner filter if provided
            if (deliverypartner) {
                allOrders = allOrders?.filter(order => order?.delivery_partner_id === deliverypartner.id);
            }

            // Filter only valid orders (payment_status === true)
            const validOrders = allOrders?.filter(order => order?.payment_status === true);

            dispatch(updatefilteredOrders(validOrders));
            dispatch(updateLoading(false))
            console.log('Valid Orders:', validOrders);
        } catch (error) {
            dispatch(updateFoodfixCutoffTime(null));
            dispatch(updateLoading(false))
            console.error("Error fetching orders:", error);
        }
        dispatch(updateorderRefresh(false))
    };

    return fetchOrders;
};

export const useDateformate = () => {

    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);
        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0');
        const year = dateObject.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return formatDate;
};

export const useFormatTime = () => {

    const formatTime = (dateString) => {
        const dateObject = new Date(dateString);
        let hours = dateObject.getHours();
        const minutes = String(dateObject.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        hours = String(hours).padStart(2, "0");
        return `${hours}:${minutes} ${ampm}`;
    };

    return formatTime;
};

// The delivery company dropdown, until the server's list arrives (delivery_company.py).
const DELIVERY_COMPANY_OPTIONS = [
    { value: 'RAPIDO', label: 'Rapido' },
    { value: 'DUNZO', label: 'Dunzo' },
    { value: 'PORTER', label: 'Porter' },
    { value: 'OWN_RIDER', label: 'Shino' },
    { value: 'OTHER', label: 'Other' },
];
// Shino's own riders: preselected, and always charged 0 (the server forces it too).
const OWN_RIDER = 'OWN_RIDER';
const DEFAULT_COMPANY_FORM = { delivery_company: OWN_RIDER, delivery_company_name: '', delivery_company_charge: '0' };

export const OrderModal = () => {
    const dispatch = useDispatch();
    const orderedProducts = useSelector(state => state.orders.orderDetails);
    const [loading, setLoading] = useState(false);
    const [declineLoading, setDeclineLoading] = useState(false);
    const partners = useSelector(state => state.orders.deliveryPartners);
    const [deliveryPartners, setDeliveryPartners] = useState([])
    const orderModal = useSelector(state => state.orders.orderModal);
    const [expanded, setExpanded] = useState(false);
    const orderDate = useSelector(state => state.orders.selectedDate)
    const hub = JSON.parse(localStorage.getItem("selected_hub") || '[]');
    const today = dayjs()

    const GetOrders = useFetchOrders()
    const formatDate = useDateformate()
    const formatTime = useFormatTime()
    useEffect(() => {
        if (!orderModal) setExpanded(false)
    }, [orderModal])
    const toast = useRef(null);
    const handleCopyDeliveryMapsUrl = async (deliveryAddress) => {
        const url = getDeliveryAddressMapUrl(deliveryAddress);
        if (!url) return;
        try {
            await navigator.clipboard.writeText(url);
            toast.current?.show({ severity: 'success', summary: 'Copied', detail: 'Map link copied to clipboard', life: 2000 });
        } catch (err) {
            console.error(err);
            toast.current?.show({ severity: 'error', summary: 'Copy failed', detail: 'Could not copy map link', life: 3000 });
        }
    };
    const deliveryMode = 1
    const [orderDetails, setOrdersDetails] = useState({})
    
    const isFoodFixOrder = (() => {
        const stored = localStorage.getItem('selected_franchise_id');
        const franchiseId = stored ? parseInt(stored, 10) : null;
        return franchiseId === 2;
    })();
    useEffect(() => {
        setOrdersDetails(orderedProducts)
    }, [orderedProducts])

    /*
     * Delivery company: who takes a home-delivery order and what we pay them.
     * Asked for when the order is marked Ready, shown as "Delivery by" in the
     * header and correctable until the order is closed. The charge is a cost,
     * never the customer's delivery fee.
     */
    const [companyInfo, setCompanyInfo] = useState(null);
    const [companyDialog, setCompanyDialog] = useState(null); // 'ready' | 'edit' | null
    const [companyForm, setCompanyForm] = useState(DEFAULT_COMPANY_FORM);
    const [companySaving, setCompanySaving] = useState(false);
    const [companyError, setCompanyError] = useState('');
    const isHomeDelivery = orderDetails?.delivery_mode == 1;
    // Same closed statuses as the server: once completed, the delivery company is locked.
    const isOrderClosed = ['delivered', 'cancelled', 'declined'].includes((orderDetails?.status || '').toLowerCase());
    const companyOptions = companyInfo?.options?.length ? companyInfo.options : DELIVERY_COMPANY_OPTIONS;

    useEffect(() => {
        setCompanyInfo(null);
        if (!orderDetails?.id || orderDetails?.delivery_mode != 1) return undefined;
        let active = true;
        CustomAxios.get(`checkout/${orderDetails.id}/delivery-company/`)
            .then((res) => { if (active) setCompanyInfo(res.data); })
            .catch(() => { /* The header just shows nothing; Ready still asks. */ });
        return () => { active = false; };
    }, [orderDetails?.id, orderDetails?.delivery_mode]);

    const openCompanyDialog = (mode) => {
        setCompanyError('');
        setCompanyForm(companyInfo?.delivery_company ? {
            delivery_company: companyInfo.delivery_company,
            delivery_company_name: companyInfo.delivery_company === 'OTHER' ? (companyInfo.delivery_company_name || '') : '',
            delivery_company_charge: companyInfo.delivery_company === OWN_RIDER ? '0' : (companyInfo.delivery_company_charge || ''),
        } : DEFAULT_COMPANY_FORM);
        setCompanyDialog(mode);
    };

    const saveCompany = async () => {
        if (companySaving) return;
        const payload = {
            delivery_company: companyForm.delivery_company,
            delivery_company_name: companyForm.delivery_company === 'OTHER' ? companyForm.delivery_company_name : '',
            delivery_company_charge: companyForm.delivery_company === OWN_RIDER ? '0' : companyForm.delivery_company_charge,
        };
        // Same checks as the server, so the common mistakes are caught here.
        if (!payload.delivery_company) return setCompanyError('Choose the delivery company.');
        if (payload.delivery_company === 'OTHER' && !payload.delivery_company_name.trim()) return setCompanyError("Enter the delivery company's name.");
        if (String(payload.delivery_company_charge).trim() === '') return setCompanyError("Enter the delivery company's charges.");
        setCompanyError('');
        setCompanySaving(true);
        try {
            if (companyDialog === 'ready') {
                const res = await CustomAxios.put(`checkout/update/${orderDetails.id}/`, { status: 'ready_for_pickup', ...payload });
                if (res?.data?.delivery_company_info) setCompanyInfo(res.data.delivery_company_info);
                dispatch(updateOrderDetails(res.data));
                orderDate != null ? GetOrders(orderDate[0], orderDate[1]) : GetOrders(today);
                toast.current.show({ severity: 'success', summary: 'Success', detail: `Order ${res.data.status} Successfully`, life: 3000 });
            } else {
                const res = await CustomAxios.put(`checkout/${orderDetails.id}/delivery-company/`, payload);
                setCompanyInfo(res.data);
                toast.current.show({ severity: 'success', summary: 'Saved', detail: 'Delivery company updated', life: 3000 });
            }
            setCompanyDialog(null);
        } catch (err) {
            setCompanyError(err?.response?.data?.message || 'Could not save. Please try again.');
        } finally {
            setCompanySaving(false);
        }
    };
    useEffect(() => {
        setDeliveryPartners(partners)
    }, [partners])
    const handleCloseOrderModal = () => {
        dispatch(updateOrderModel(false))
        dispatch(updateOrderDetails({}))
        dispatch(updateselectedDeliveryPartner(""))
    };
    const handleStatusChange = async (id, newStatus, partner) => {
        try {
            setLoading(true)
            if (newStatus == 'declined') setDeclineLoading(true)
            await CustomAxios.put(`checkout/update/${id}/`, { status: newStatus, partnerId: partner }).then((res) => {
                console.log("--------------`checkout/update/------------------", res, orderDate)
                if (res.data) {
                    console.log("hereee")
                    if (newStatus == "delivery_partner_assigned") {
                        console.log("we were here first")
                        delivery_update(id, partner)
                        toast.current.show({ severity: 'success', summary: 'Success', detail: `Delivery Partner Assigned Successfully`, life: 3000 })
                        dispatch(updateselectedDeliveryPartner(res.data.delivery_partner_id))
                        dispatch(updateOrderDetails(res.data))
                        dispatch(updatePartnerAssignModal(false))
                        // dispatch(updateOrderModel(false))
                    }
                    else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: `Order ${res.data.status} Successfully`, life: 3000 })
                        dispatch(updateOrderDetails(res.data))
                    }

                    orderDate != null ? GetOrders(orderDate[0], orderDate[1]) : GetOrders(today)
                    dispatch(updateUpdatedDate(partner?.created_on))
                    setLoading(false)
                    setDeclineLoading(false)

                }
            })

        } catch (err) {
            console.error("Error updating status:", err);
            setLoading(false); // End loading
            setDeclineLoading(false)
        } finally {
            setLoading(false); // End loading
            setDeclineLoading(false)
        }
    };
    const delivery_update = async (id, partner) => {
        console.log("we are here", typeof (partner), deliveryPartners)
        const delivery_partner = deliveryPartners.find((part) => part.id == partner)
        console.log("////////////////////////////////////", delivery_partner)
        const response = await CustomAxiosDP.post('delivery_create/', { mobileno: delivery_partner.mobileno, delivery_mode: deliveryMode, delivery_status: "Pending", user_checkout_id: id }).then((response) => {
            console.log(response.status)
            console.log(response.data.message)
        })
    }
    console.log(orderModal)

    const confirmDecline = (item, which) => {
        console.log(item, which)
        const paymentMethod = item.paymentmethod?.toLowerCase();
        const allowedPaymentMethods = ['cash', 'online', 'swiggy', 'zomato'];
        const showRefundText = !allowedPaymentMethods.includes(paymentMethod);
        
        confirmDialog({
            message: (
                <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
                    {which == "decline" ? <><Typography sx={{ fontSize: "16px", fontWeight: 500 }}>Do you want to cancel this Order </Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
                            The order {item.order_id} will be canceled{showRefundText ? ', and the refund will be initiated.' : '.'}
                        </Typography></> :
                        <><Typography sx={{ fontSize: "14px", fontWeight: 400 }}>Are You Sure </Typography>
                            <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>Do you want to initiate refund for this Order. </Typography>
                        </>
                    }
                </Box>
            ),
            header: which == "decline" ? 'Cancel Order' : "Refund",
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => accept(item),
        });
    };

    const billingMachine = async () => {
        try {
          // Make the API call to generate the PDF
          const response = await CustomAxios.post("/bill_machine/", {
            user_id: orderDetails.user,
            order_id: orderDetails.order_id,
          }, {
            responseType: "blob" // important! ensures Axios returns a Blob
          });
      
          // Convert the response to a Blob and create a URL
          const blob = new Blob([response.data], { type: "application/pdf" });
          const pdfUrl = URL.createObjectURL(blob);
      
          // Create a hidden iframe
          const iframe = document.createElement("iframe");
          iframe.style.display = "none";
          iframe.src = pdfUrl;
          document.body.appendChild(iframe);
      
          // Wait for PDF to load and call print
          iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            // Optionally remove the iframe after printing
            setTimeout(() => document.body.removeChild(iframe), 15000);
          };
        } catch (error) {
          console.error(error);
          alert("Failed to generate PDF. Please try again.");
        }
      };
    console.log("/////////////////order details", orderDetails)

    const accept = async (item) => {
        try {
            const paymentMethod = item.paymentmethod?.toLowerCase();
            const allowedPaymentMethods = ['cash', 'online', 'swiggy', 'zomato'];
            
            if (allowedPaymentMethods.includes(paymentMethod)) {
                // Update checkout status as cancelled for cash, online, swiggy, or zomato
                await CustomAxios.put(`checkout/update/${item.id}/`, { status: 'cancelled' }).then((res) => {
                    if (res.data) {
                        console.log(res.data)
                        dispatch(updateOrderDetails(res.data))
                        orderDate != null ? GetOrders(orderDate[0], orderDate[1]) : GetOrders(today)
                        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Order cancelled Successfully', life: 3000 });
                    }
                })
            } else {
                // Use refund endpoint for other payment methods
                const response = await CustomAxios.post(`/cancel_order_razor/`, {
                    user_id: item.user,
                    order_id: item.order_id,
                    hub_id: hub,
                    cancelled_by: "store"
                }).then((res) => {
                    if (res.data.message == "refund initiated successfully") {
                        console.log(res.data)
                        dispatch(updateOrderDetails(res.data.order))
                        orderDate != null ? GetOrders(orderDate[0], orderDate[1]) : GetOrders(today)
                        // GetOrders()
                        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Order cancelled Successfully', life: 3000 });
                    }
                })
            }
        } catch (error) {
            console.error("Error fetching order details:", error);
        }
    }

    const toBullets = (text) => {
        if (!text) return [];
            // turn literal "\n" into real newlines, then split
            const normalized = text.replace(/\\n/g, '\n');
            return normalized
                .split(/\n|•/g)        
                .map(s => s.trim())
                .filter(Boolean)
                .map(line => {
                // Capitalize first character only; non-Latin stays unaffected
                return line.charAt(0).toUpperCase() + line.slice(1);
                });
    };

    return (
        <Box>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Modal
                open={orderModal}
                onClose={handleCloseOrderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ zIndex: 1000 }}
            >
                <Box sx={{ 
                    position: 'absolute', 
                    top: '50%', 
                    left: '50%', 
                    transform: 'translate(-50%, -50%)', 
                    width: expanded ? { xs: 'calc(100vw - 16px)', md: 'calc(100vw - 32px)' } : { xs: '95%', sm: '90%', md: '100%' }, 
                    maxWidth: expanded ? 'none' : { xs: '100%', sm: '600px', md: "1100px" }, 
                    height: expanded ? { xs: 'calc(100vh - 16px)', md: 'calc(100vh - 32px)' } : { xs: "90vh", sm: "85vh", md: "550px" }, 
                    maxHeight: expanded ? 'none' : { xs: "90vh", sm: "85vh", md: "550px" },
                    backgroundColor: 'white',
                    borderRadius: expanded ? '8px' : { xs: '8px', md: '0px' },
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}>

                    <Box sx={{ 
                        height: { xs: "40px", md: "46px" }, 
                        padding: { xs: "8px 12px", sm: "12px 16px", md: "12px 24px" }, 
                        backgroundColor: "#EEEEEE", 
                        display: "flex", 
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexShrink: 0
                    }}>
                        <Typography sx={{ fontSize: { xs: "12px", sm: "14px", lg:"14px" }, fontWeight: "500", lineHeight: "22px" }}>Order ID: {orderDetails.order_id}</Typography>
                        <Tooltip title={expanded ? "Collapse" : "Expand"} arrow>
                            <IconButton size="small" aria-label={expanded ? "Collapse order details" : "Expand order details"} onClick={() => setExpanded(prev => !prev)}>
                                {expanded ? <CloseFullscreenIcon fontSize="small" /> : <OpenInFullIcon fontSize="small" />}
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Box sx={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        padding: { xs: "12px", sm: "16px", md: "24px" }, 
                        gap: { xs: "12px", sm: "16px", md: "20px" },
                        height: expanded ? "auto" : { xs: "calc(90vh - 120px)", sm: "calc(85vh - 120px)", md: "400px" },
                        minHeight: 0,
                        overflowY: "auto",
                        flex: 1
                    }}>
                        <Box sx={{ display: "flex", gap: { xs: "12px", sm: "16px", md: "24px" }, width: "100%", flexDirection: { xs: "column", md: "row" }, flexWrap: "wrap" }}>
                            {orderDetails.delivery_mode === 1 ? <Box sx={{ display: "flex", gap: "4px", flexDirection: "column", width: { xs: "100%", md: "350px" } }}>
                                <Typography sx={{ fontSize: { xs: "10px", sm: "12px" }, fontWeight: "700", lineHeight: "18px" }}>Customer Delivery Details</Typography>
                                <Box>
                                    {isFoodFixOrder && (orderDetails.stall_name || orderDetails?.delivery_address) && (
                                        <>
                                            {orderDetails?.delivery_address?.street && (
                                                <Typography sx={{ fontSize: { xs: "10px", sm: "11px" }, fontWeight: "600", lineHeight: "18px", color: "#1976d2" }}>
                                                    Stall: {orderDetails?.delivery_address?.street}
                                                </Typography>
                                            )}
                                            {/* Address like CartPage for FoodFix */}
                                            <Typography sx={{ fontSize: { xs: "9px", sm: "10px", lg:"14px"}, fontWeight: 500, lineHeight: "16px", color: "#6B7280" }}>Delivery Address</Typography>
                                            <Box sx={{ display: "flex",  gap: 0.5, flexDirection: "column" }}>
                                                <Typography sx={{ flex: 1, minWidth: 0, fontSize: { xs: "9px", sm: "10px", lg:"14px"}, fontWeight: 600, lineHeight: "16px", color: "black" }}>
                                                    {` ${orderDetails?.delivery_address?.address || 'No address'}, ${orderDetails?.delivery_address?.state_country || ''} ${orderDetails?.delivery_address?.pin || ''}`}
                                                </Typography>
                                                {getDeliveryAddressMapUrl(orderDetails?.delivery_address) && (
                                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, flexShrink: 0, alignItems: "center" }}>
                                                        <Button size="small" variant="outlined" sx={{ textTransform: "none", minWidth: 0, px: 1, fontSize: { xs: "10px", sm: "11px", lg: "12px" } }} onClick={() => openDeliveryAddressInMap(orderDetails?.delivery_address)}>Map</Button>
                                                        <Button size="small" variant="outlined" sx={{ textTransform: "none", minWidth: 0, px: 1, fontSize: { xs: "10px", sm: "11px", lg: "12px" } }} onClick={() => handleCopyDeliveryMapsUrl(orderDetails?.delivery_address)}>Copy URL</Button>
                                                    </Box>
                                                )}
                                            </Box>
                                            {orderDetails?.delivery_address?.hub_name && (
                                                <Typography sx={{ fontSize: { xs: "9px", sm: "10px" ,lg:"14px"}, lineHeight: "16px", color: "black" }}>
                                                    {`Hub: ${orderDetails.delivery_address.hub_name}`}
                                                </Typography>
                                            )}
                                        </>
                                    )}
                                    {!isFoodFixOrder && (
                                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5,flexDirection: "column" }}>
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography sx={{ fontSize: { xs: "10px", sm: "11px", lg:"14px"}, fontWeight: "400", lineHeight: "18px" }}>{orderDetails?.delivery_address?.name} </Typography>
                                                <Typography sx={{ fontSize: { xs: "10px", sm: "11px" ,lg:"14px"}, fontWeight: "400", lineHeight: "18px" }}>{orderDetails?.delivery_address?.door_flat_no} ,{orderDetails?.delivery_address?.address}</Typography>
                                                <Typography sx={{ fontSize: { xs: "10px", sm: "11px" ,lg:"14px"}, fontWeight: "400", lineHeight: "18px" }}>{orderDetails?.delivery_address?.pin}</Typography>
                                            </Box>
                                            {getDeliveryAddressMapUrl(orderDetails?.delivery_address) && (
                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, flexShrink: 0, alignItems: "flex-start", alignSelf: "flex-start" }}>
                                                    <Button size="small" variant="outlined" sx={{ textTransform: "none", minWidth: 0, px: 1, fontSize: { xs: "10px", sm: "11px", lg: "12px" } }} onClick={() => openDeliveryAddressInMap(orderDetails?.delivery_address)}>Map</Button>
                                                    <Button size="small" variant="outlined" sx={{ textTransform: "none", minWidth: 0, px: 1, fontSize: { xs: "10px", sm: "11px", lg: "12px" } }} onClick={() => handleCopyDeliveryMapsUrl(orderDetails?.delivery_address)}>Copy URL</Button>
                                                </Box>
                                            )}
                                        </Box>
                                    )}
                                </Box>
                                <DeliveryLocationMap deliveryAddress={orderDetails?.delivery_address} />
                            </Box> : <Box sx={{ display: "flex", gap: "4px", flexDirection: "column", width: { xs: "100%", md: "350px" } }}>
                                <Typography sx={{ fontSize: { xs: "10px", sm: "12px", lg:"14px" }, fontWeight: "700", lineHeight: "18px" }}>Customer Details</Typography>
                                <Box>
                                    {isFoodFixOrder && (orderDetails.stall_name || orderDetails?.delivery_address) && (
                                        <>
                                            {orderDetails.stall_name && (
                                                <Typography sx={{ fontSize: { xs: "10px", sm: "11px" }, fontWeight: "600", lineHeight: "18px", color: "#1976d2" }}>
                                                    Stall: {orderDetails.stall_name}
                                                </Typography>
                                            )}
                                            <Typography sx={{ fontSize: { xs: "9px", sm: "10px", lg:"14px" }, fontWeight: 500, lineHeight: "16px", color: "#6B7280" }}>Pickup Address</Typography>
                                            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5 }}>
                                                <Typography sx={{ flex: 1, minWidth: 0, fontSize: { xs: "9px", sm: "10px", lg:"14px" }, fontWeight: 600, lineHeight: "16px", color: "black" }}>
                                                    {`Address: ${orderDetails?.delivery_address?.address || 'No address'}, ${orderDetails?.delivery_address?.state_country || ''} ${orderDetails?.delivery_address?.pin || ''}`}
                                                </Typography>
                                                {getDeliveryAddressMapUrl(orderDetails?.delivery_address) && (
                                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, flexShrink: 0, alignItems: "center" }}>
                                                        <Button size="small" variant="outlined" sx={{ textTransform: "none", minWidth: 0, px: 1, fontSize: { xs: "10px", sm: "11px", lg: "12px" } }} onClick={() => openDeliveryAddressInMap(orderDetails?.delivery_address)}>Map</Button>
                                                        <Button size="small" variant="outlined" sx={{ textTransform: "none", minWidth: 0, px: 1, fontSize: { xs: "10px", sm: "11px", lg: "12px" } }} onClick={() => handleCopyDeliveryMapsUrl(orderDetails?.delivery_address)}>Copy URL</Button>
                                                    </Box>
                                                )}
                                            </Box>
                                            {orderDetails?.delivery_address?.hub_name && (
                                                <Typography sx={{ fontSize: { xs: "9px", sm: "10px", lg:"14px" }, lineHeight: "16px", color: "black" }}>
                                                    {`Hub: ${orderDetails.delivery_address.hub_name}`}
                                                </Typography>
                                            )}
                                        </>
                                    )}
                                    {!isFoodFixOrder && (
                                        <>
                                            <Typography sx={{ fontSize: { xs: "10px", sm: "11px", lg:"14px" }, fontWeight: "400", lineHeight: "18px" }}>Customer Name: {orderDetails.user_details?.first_name} {orderDetails.user_details?.last_name}</Typography>
                                            <Typography sx={{ fontSize: { xs: "10px", sm: "11px",lg:"14px" }, fontWeight: "400", lineHeight: "18px" }}>Mobile No: {orderDetails.user_details?.mobileno}</Typography>
                                        </>
                                    )}
                                </Box>
                            </Box>}
                            <Box sx={{ display: "flex", gap: "4px", flexDirection: "column", width: { xs: "100%", sm: "calc(50% - 12px)", md: "200px" } }}>
                                <Typography sx={{ fontSize: { xs: "10px", sm: "12px", lg:"14px" }, fontWeight: "700", lineHeight: "18px" }}>Order on</Typography>
                                <Typography sx={{ fontSize: { xs: "10px", sm: "11px" ,lg:"14px"}, fontWeight: "400", lineHeight: "18px" }}>{formatDate(orderDetails.created_on)}</Typography>
                                <Typography sx={{ fontSize: { xs: "9px", sm: "10px" ,lg:"14px"}, fontWeight: "400", lineHeight: "16px" }}>{formatTime(orderDetails.created_on)}</Typography>
                            </Box>
                           
                            <Box sx={{ display: "flex", gap: "4px", flexDirection: "column", width: { xs: "100%", sm: "calc(50% - 12px)", md: "200px" } }}>
                                <Typography sx={{ fontSize: { xs: "10px", sm: "12px", lg:"14px" }, fontWeight: "700", lineHeight: "18px" }}>Order Status</Typography>
                                <Typography sx={{ fontSize: { xs: "10px", sm: "11px" ,lg:"14px"}, fontWeight: "400", lineHeight: "18px" }}>{orderDetails.status}</Typography>
                                {/* <Select
                                    labelId={`status-label-${orderDetails.id}`}
                                    value={orderDetails.status}
                                    onChange={(e) => handleStatusChange(orderDetails.id, e.target.value, orderDetails)}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                backgroundColor: 'white',
                                            },
                                        },
                                    }}
                                    sx={{ textAlign:"left",width: "200px", height: "32px", backgroundColor: orderDetails.status == "declined"?"#FFF1F2":orderDetails.status == "delivered" ? "#F6FFED" : orderDetails.status == "pending"?"#E6F1F8":orderDetails.status == "delivery_partner_assigned"?"#FFF7EB":"#F9FAFB",
                                     color: orderDetails.status == "declined"?"#E11D48":orderDetails.status == "delivered" ? "#52C41A" :orderDetails.status == "pending"?"#0071BC":orderDetails.status == "delivery_partner_assigned"?"#FBB03B": "#6B7280",
                                     borderColor: orderDetails.status == "declined"?"#E11D48":orderDetails.status == "delivered" ? "#F6FFED" : orderDetails.status == "pending"?"#E6F1F8":orderDetails.status == "delivery_partner_assigned"?"#FBB03B":"#F9FAFB",border:"1 px solid" }}
                                >
                                    <MenuItem value="pending" >Pending</MenuItem>
                                    <MenuItem value="accepted"  >Accepted</MenuItem>
                                    <MenuItem value="declined"  >Declined</MenuItem>
                                    <MenuItem value="delivery_partner_assigned" >Delivery partner assigned</MenuItem>
                                    <MenuItem value="delivery_partner_accepted" >Delivery partner accepted</MenuItem>
                                    <MenuItem value="delivered" >Delivered</MenuItem>
                                </Select> */}
                            </Box>
                            {isHomeDelivery && !isFoodFixOrder && companyInfo && (companyInfo.delivery_company || ['ready_for_pickup', 'order_picked_up'].includes(orderDetails.status)) && (
                                <Box sx={{ display: "flex", gap: "4px", flexDirection: "column", width: { xs: "100%", sm: "calc(50% - 12px)", md: "200px" } }}>
                                    <Typography sx={{ fontSize: { xs: "10px", sm: "12px", lg:"14px" }, fontWeight: "700", lineHeight: "18px" }}>Delivery by</Typography>
                                    <Typography sx={{ fontSize: { xs: "10px", sm: "11px" ,lg:"14px"}, fontWeight: "400", lineHeight: "18px" }}>
                                        {companyInfo.delivery_company
                                            ? `${companyInfo.delivery_company_name} · Rs ${companyInfo.delivery_company_charge}`
                                            : 'Not set'}
                                    </Typography>
                                    {companyInfo.editable && !isOrderClosed && (
                                        <Typography
                                            component="button"
                                            type="button"
                                            onClick={() => openCompanyDialog('edit')}
                                            sx={{ alignSelf: "flex-start", p: 0, border: "none", background: "none", cursor: "pointer", color: "primary.button", fontSize: { xs: "10px", sm: "11px", lg: "13px" }, fontWeight: "600", textDecoration: "underline" }}
                                        >
                                            {companyInfo.delivery_company ? 'Edit' : 'Add'}
                                        </Typography>
                                    )}
                                </Box>
                            )}
                            {orderDetails.offer !== null && orderDetails.matched_offer?.length > 0 && (
                                <Box sx={{ display: "flex", gap: "4px", flexDirection: "column", width: { xs: "100%", md: "350px" } }}>
                                    <Typography sx={{ fontSize: { xs: "10px", sm: "12px", lg:"14px" }, fontWeight: "700", lineHeight: "18px" }}>
                                        Offer Claimed
                                    </Typography>

                                    <Box>
                                        <Box sx={{ display: "flex", gap: { xs: "8px", sm: "16px", lg:"14px"}, flexDirection: "row", flexWrap: "wrap" }}>
                                            {orderDetails.matched_offer.map((item) => (
                                                <Box key={item.id} sx={{ display: "flex", alignItems: "center" }}>
                                                    <Box
                                                        component="img"
                                                        src={item.offer_products?.images?.[0] || '/placeholder.png'}  // fallback image if not available
                                                        sx={{ width: { xs: "28px", sm: "36px"}, height: { xs: "28px", sm: "36px" }, borderRadius: "8px", marginRight: { xs: "6px", sm: "10px" } }}
                                                    />
                                                    <Box sx={{ display: "flex", gap: "8px" }}>
                                                        <Typography sx={{ fontSize: { xs: "9px", sm: "11px", lg:"14px"}, fontWeight: "400", lineHeight: "18px" }}>
                                                            {item.offer_name}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                            {orderDetails.delivery_mode == 1 && <Box sx={{ display: "flex", gap: "4px", flexDirection: "column", width: { xs: "100%", sm: "calc(50% - 12px)", md: "200px" } }}>
                                <Typography sx={{ fontSize: { xs: "10px", sm: "12px", lg:"14px" }, fontWeight: "700", lineHeight: "18px" }}>{orderDetails.delivery_mode === 1 ? "Delivery Partner" : "Customer"}</Typography>
                                <Button variant="contained" disabled={orderDetails.status === 'declined' || orderDetails.status === 'delivered' || orderDetails.status === 'cancelled'} sx={{ textTransform: "none", height: { xs: "26px", sm: "30px" }, width: { xs: "100%", sm: "200px" }, fontSize: { xs: "10px", sm: "12px" } }} onClick={() => dispatch(updatePartnerAssignModal(true))} > {orderDetails.delivery_partner_id == 0 || orderDetails.delivery_partner_id == null ? 'Assign' : 'Assigned'}</Button>
                            </Box>}

                        </Box>
                            {orderDetails?.order_instructions && (
                                <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column'}}>
                                    <Typography sx={{ fontSize: { xs: 10, sm: 12 }, fontWeight: 700, lineHeight: '18px' }}>
                                    Order Instruction
                                    </Typography>

                                    <Box component="ul" sx={{ m: 0, pl: 2 }}>
                                    {toBullets(orderDetails.order_instructions).map((item, i) => (
                                        <Typography
                                        key={i}
                                        component="li"
                                        sx={{ fontSize: { xs: 10, sm: 11 }, lineHeight: '18px' }}
                                        >
                                        {item}
                                        </Typography>
                                    ))}
                                    </Box>
                                </Box>
                            )}
                        <OrderProductsTable expanded={expanded} />
                    </Box>
                    <Box sx={{ 
                        backgroundColor: "#EEEEEE", 
                        display: "flex", 
                        alignItems: "center", 
                        position: expanded ? "relative" : { xs: "relative", md: "absolute" },
                        bottom: 0, 
                        justifyContent: { xs: "center", md: "flex-end" }, 
                        width: "100%",
                        flexShrink: 0,
                        padding: { xs: "8px", sm: "12px 16px", md: "12px 24px" }
                    }}>
                        <Box sx={{ 
                            display: "flex", 
                            gap: { xs: "8px", sm: "12px", md: "20px" },
                            flexWrap: "wrap",
                            justifyContent: { xs: "center", md: "flex-end" },
                            width: "100%"
                        }}>
                                <Button variant="outlined" sx={{ 
                                    textTransform: "none", 
                                    color: "black",
                                    fontSize: { xs: "11px", sm: "14px" },
                                    padding: { xs: "6px 12px", sm: "8px 16px" },
                                    minWidth: { xs: "80px", sm: "auto" }
                                }} onClick={() => dispatch(updateOrderModel(false))}>
                                    Close
                                </Button>
                                <Button variant="outlined" sx={{ 
                                    textTransform: "none", 
                                    color: "black",
                                    fontSize: { xs: "11px", sm: "14px" },
                                    padding: { xs: "6px 12px", sm: "8px 16px" },
                                    minWidth: { xs: "80px", sm: "auto" }
                                }} onClick={() => billingMachine()}>
                                    Print Bill
                                </Button>
                                {(orderDetails.status === 'cancelled' && orderDetails.cancel_request == true) && <Button variant="contained" sx={{ 
                                    textTransform: "none", 
                                    color: "white", 
                                    backgroundColor: "primary.button", 
                                    width: { xs: "100%", sm: "200px" },
                                    fontSize: { xs: "11px", sm: "14px" },
                                    padding: { xs: "6px 12px", sm: "8px 16px" }
                                }} onClick={() => confirmDecline(orderDetails, "refund")} >
                                    Refund
                                </Button>}
                                {orderDetails.status === 'cancelled' ? <Button variant="contained" disabled={orderDetails.status === 'cancelled'} sx={{ 
                                    textTransform: "none", 
                                    color: "black", 
                                    backgroundColor: "white", 
                                    width: { xs: "100%", sm: "200px" },
                                    fontSize: { xs: "11px", sm: "14px" },
                                    padding: { xs: "6px 12px", sm: "8px 16px" }
                                }} >
                                    Order Cancelled
                                </Button> :
                                    <> <Button variant="outlined" disabled={orderDetails.status === 'declined' || (orderDetails.status === 'delivered' && !['cash', 'swiggy', 'online', 'zomato'].includes(orderDetails.paymentmethod?.toLowerCase()))} sx={{ 
                                        textTransform: "none", 
                                        color: "black", 
                                        backgroundColor: "white", 
                                        width: { xs: "100%", sm: "200px" },
                                        fontSize: { xs: "11px", sm: "14px" },
                                        padding: { xs: "6px 12px", sm: "8px 16px" }
                                    }} onClick={() => confirmDecline(orderDetails, "decline")}>
                                        {orderDetails.status == 'declined' ? 'Order Declined' : declineLoading ? <CircularProgress size="18px" sx={{ color: "primary.button" }} /> : 'Decline'}
                                    </Button>
                                        {orderDetails.delivery_mode == 1 && !isFoodFixOrder ?
                                            <Button
                                                disabled={orderDetails.status == 'delivered' || loading ? true : false}
                                                variant="contained"
                                                sx={{ 
                                                    textTransform: "none", 
                                                    height: { xs: "28px", sm: "32px" }, 
                                                    width: { xs: "100%", sm: "200px" }, 
                                                    backgroundColor: orderDetails.status == 'delivered' ? "#F6FFED" : "primary.button",
                                                    fontSize: { xs: "11px", sm: "14px" },
                                                    padding: { xs: "6px 12px", sm: "8px 16px" }
                                                }}
                                                onClick={() => orderDetails.status == 'accepted' || orderDetails.status == 'delivery_partner_accepted' || orderDetails.status == 'delivery_partner_assigned' ? openCompanyDialog('ready')
                                                    : orderDetails.status == "ready_for_pickup" || orderDetails.status == 'order_picked_up' ? handleStatusChange(orderDetails.id, 'delivered')
                                                        : handleStatusChange(orderDetails.id, 'accepted')} >
                                                {loading ? <CircularProgress size="25px" sx={{ color: "white" }} /> : orderDetails.status == 'accepted' || orderDetails.status == 'delivery_partner_accepted' || orderDetails.status == 'delivery_partner_assigned' ? 'Ready' : orderDetails.status == 'delivered' ? <Button sx={{ textTransform: "none", color: "black", height: "32px", border: "none" }} >Order completed</Button>
                                                    : orderDetails.status == 'ready_for_pickup' || orderDetails.status == 'order_picked_up' ? <Tooltip placement="top" title="Update the order status to 'Delivered' if the status update was missed by the delivery partner." arrow><Button sx={{ textTransform: "none", color: "white", height: "32px", border: "none" }} >Delivered ?</Button> </Tooltip> :
                                                        'Accept'}
                                            </Button>
                                            : !isFoodFixOrder ? <Button
                                                disabled={orderDetails.status == 'delivered' || orderDetails.status == 'picked' || loading ? true : false}
                                                variant="contained"
                                                sx={{ 
                                                    textTransform: "none", 
                                                    height: { xs: "28px", sm: "32px" }, 
                                                    width: { xs: "100%", sm: "200px" }, 
                                                    backgroundColor: orderDetails.status == 'picked' ? "#F6FFED" : "primary.button",
                                                    fontSize: { xs: "11px", sm: "14px" },
                                                    padding: { xs: "6px 12px", sm: "8px 16px" }
                                                }}
                                                onClick={() => orderDetails.status == 'accepted' ? handleStatusChange(orderDetails.id, 'ready_for_pickup')
                                                    : orderDetails.status == 'ready_for_pickup' ? handleStatusChange(orderDetails.id, 'delivered')
                                                        : handleStatusChange(orderDetails.id, 'accepted')} >
                                                {loading ? <CircularProgress size="25px" sx={{ color: "white" }} /> : orderDetails.status == 'delivered' ? <Button sx={{ textTransform: "none", color: "black", height: "32px", border: "none" }} >Order completed</Button>
                                                    : orderDetails.status == 'accepted' ? <Tooltip placement="top" title="Update the order status to 'Delivered' if the status update was missed by the delivery partner." arrow><Button sx={{ textTransform: "none", color: "white", height: "32px", border: "none" }} >Ready</Button> </Tooltip>
                                                        : orderDetails.status == 'ready_for_pickup' ? <Tooltip placement="top" title="Update the order status to 'Delivered' if the status update was missed by the delivery partner." arrow><Button sx={{ textTransform: "none", color: "white", height: "32px", border: "none" }} >Picked Up ?</Button> </Tooltip>
                                                            : 'Accept'}
                                            </Button> : null}
                                    </>

                                }
                        </Box>
                    </Box>
                </Box>
            </Modal>
            <Dialog open={Boolean(companyDialog)} onClose={() => !companySaving && setCompanyDialog(null)} fullWidth maxWidth="xs">
                <DialogTitle sx={{ pb: 0.5 }}>
                    {companyDialog === 'ready' ? 'Send for delivery' : 'Delivery company'}
                    <Typography sx={{ fontSize: "12.5px", color: "text.secondary", mt: 0.5 }}>
                        Order {orderDetails.order_id}{orderDetails.total_amount ? ` · Rs ${orderDetails.total_amount}` : ''}
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: "12px !important" }}>
                    <FormControl fullWidth size="small">
                        <InputLabel id="delivery-company-label">Delivery company *</InputLabel>
                        <Select
                            labelId="delivery-company-label"
                            id="delivery-company"
                            label="Delivery company *"
                            value={companyForm.delivery_company}
                            onChange={(e) => {
                                const company = e.target.value;
                                // Shino is always 0; leaving Shino clears that 0 so the real charge is entered.
                                const charge = company === OWN_RIDER ? '0'
                                    : companyForm.delivery_company === OWN_RIDER ? '' : companyForm.delivery_company_charge;
                                setCompanyForm({ ...companyForm, delivery_company: company, delivery_company_charge: charge });
                            }}
                        >
                            {companyOptions.map((o) => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
                        </Select>
                    </FormControl>
                    {companyForm.delivery_company === 'OTHER' && (
                        <TextField
                            id="delivery-company-name"
                            size="small"
                            label="Company name *"
                            placeholder="Type the delivery company's name"
                            autoFocus
                            value={companyForm.delivery_company_name}
                            onChange={(e) => setCompanyForm({ ...companyForm, delivery_company_name: e.target.value })}
                            inputProps={{ maxLength: 60 }}
                        />
                    )}
                    <TextField
                        id="delivery-company-charge"
                        size="small"
                        label="Delivery charges (Rs) *"
                        type="number"
                        value={companyForm.delivery_company === OWN_RIDER ? '0' : companyForm.delivery_company_charge}
                        onChange={(e) => setCompanyForm({ ...companyForm, delivery_company_charge: e.target.value })}
                        disabled={companyForm.delivery_company === OWN_RIDER}
                        inputProps={{ min: 0, max: Number(companyInfo?.max_charge || 5000), step: "0.01" }}
                        helperText={companyForm.delivery_company === OWN_RIDER
                            ? "Shino's own riders: no charge."
                            : "What we pay the delivery company. Not added to the customer's bill."}
                    />
                    {companyError ? <Typography sx={{ color: "error.main", fontSize: "13px" }}>{companyError}</Typography> : null}
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button variant="outlined" sx={{ textTransform: "none" }} disabled={companySaving} onClick={() => setCompanyDialog(null)}>Cancel</Button>
                    <Button variant="contained" sx={{ textTransform: "none", backgroundColor: "primary.button" }} disabled={companySaving} onClick={saveCompany}>
                        {companySaving ? <CircularProgress size="20px" sx={{ color: "white" }} /> : companyDialog === 'ready' ? 'Mark ready' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>

    )
}

export const OrderModalDelivery = () => {
    const dispatch = useDispatch();
    const orderedProducts = useSelector(state => state.orders.orderDetails);
    const [loading, setLoading] = useState(false);
    const partners = useSelector(state => state.orders.deliveryPartners);
    //const newpartners = useSelector(state => state.orders.newdeliveryPartners);
    const [deliveryPartners, setDeliveryPartners] = useState([])
    const orderModal = useSelector(state => state.orders.orderModal);
    const GetOrders = useFetchOrders()
    const deliveryPartnerModal = useSelector(state => state.orders.partnerAssignModal);
    const selectedDeliveryPartner = useSelector(state => state.orders.selectedDeliveryPartner);
    const selectedStalls = useSelector(state => state.orders.selectedStalls);
    const orderList = useSelector(state => state.orders.filteredOrders);
    const hub = useSelector(state => state.user.selected_hub);
    const orderDate = useSelector(state => state.orders.selectedDate)
    const today = dayjs()

    //const [selectedDeliveryPartner, setSelectedDeliveryPartner] = useState({})
    const toast = useRef(null);
    const deliveryMode = 1
    const [orderDetails, setOrdersDetails] = useState({})
    useEffect(() => {
        setOrdersDetails(orderedProducts)
    }, [orderedProducts])


    useEffect(() => {
        let hubId;

        // 1. Try getting from Redux
        if (Array.isArray(hub) && hub.length > 0) {
            hubId = hub[0]; // Use the first hub (you can change logic if needed)
        }

        // 2. Fallback to localStorage if hubId is missing/invalid
        if (!hubId || isNaN(hubId)) {
            const localHub = localStorage.getItem("selected_hub");
            if (localHub && !isNaN(parseInt(localHub))) {
                hubId = parseInt(localHub);
            }
        }

        // 3. If we have a valid hubId, filter partners
        if (hubId && partners.length > 0) {
            const filtered = partners.filter(p => p.inventory_Id === hubId);
            console.log("✅ Filtered partners:", filtered, "with hubId:", hubId);
            setDeliveryPartners(filtered);
        } else {
            console.warn("⚠️ No valid hubId found or no partners available.");
        }
    }, [partners, hub]);


    const handleClosedeliveryPartnerModal = () => {
        dispatch(updateselectedDeliveryPartner(""))
        dispatch(updatePartnerAssignModal(false))
    };
    const handleStatusChange = async (id, newStatus, partner) => {
        try {
            setLoading(true)
            await CustomAxios.put(`checkout/update/${id}/`, { status: newStatus, partnerId: partner.id }).then((res) => {
                console.log("--------------`checkout/update/------------------", res, orderDate)
                if (res.data) {
                    console.log("hereee")
                    if (newStatus == "delivery_partner_assigned") {
                        console.log("we were here first")
                        // delivery_update(id, partner)
                        toast.current.show({ severity: 'success', summary: 'Success', detail: `Delivery Partner Assigned Successfully`, life: 3000 })
                        dispatch(updateselectedDeliveryPartner(res.data.delivery_partner_id))
                        dispatch(updateOrderDetails(res.data))
                        dispatch(updatePartnerAssignModal(false))
                        // dispatch(updateOrderModel(false))
                    }
                    else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: `Order ${res.data.status} Successfully`, life: 3000 })
                        dispatch(updateOrderDetails(res.data))
                    }

                    dispatch(updateUpdatedDate(partner.created_on))
                    setLoading(false)
                    orderDate != null ? GetOrders(orderDate[0], orderDate[1]) : GetOrders(today)
                }
            })

        } catch (err) {
            console.error("Error updating status:", err);
            setLoading(false); // End loading
        } finally {
            setLoading(false); // End loading
        }
    };
    const delivery_update = async (id, newStatus, partner) => {
        console.log("we are here", typeof (partner), deliveryPartners, partner)
        const delivery_partner = deliveryPartners.find((part) => part.id == partner.id)
        console.log("////////////////////////////////////", delivery_partner)
        
        // Check if this is franchise ID 2
        const franchiseId = localStorage.getItem('selected_franchise_id');
        const isFranchise2 = franchiseId && parseInt(franchiseId) === 2;
        
        if (isFranchise2) {
            // For franchise ID 2, get all orders from selected stalls (same pattern as bulk functions)
            // Function to filter orders by selected stalls (same as in order_lists.js)
            const filterOrdersByStalls = (ordersList) => {
                if (selectedStalls.length === 0) {
                    return ordersList;
                }
                
                return ordersList.filter(order => {
                    const orderStallId = order.stall_id;
                    return selectedStalls.some(stall => {
                        const selectedStallId = typeof stall === 'object' ? stall.id : stall;
                        return selectedStallId === orderStallId;
                    });
                });
            };
            
            const filteredOrders = filterOrdersByStalls(orderList);
            const eligibleOrders = filteredOrders.filter(o => o.status !== 'delivered' && o.status !== 'cancelled' );
            
            if (eligibleOrders.length === 0) {
                toast.current.show({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: 'No eligible orders found for selected stalls', 
                    life: 3000 
                });
                return;
            }
            
            console.log("🍽️ Bulk assignment for franchise 2 with filtered orders:", eligibleOrders.map(o => o.id));
            
            // Send all order IDs as array in user_checkout_id
            const orderIds = eligibleOrders.map(order => order.id);
            const response = await CustomAxiosDP.post('delivery_create/', { 
                mobileno: delivery_partner.mobileno, 
                delivery_mode: deliveryMode, 
                delivery_status: "Pending", 
                user_checkout_id: orderIds 
            }).then((response) => {
                console.log(response.status)
                console.log(response.data.message)

                if (response.data.message == 'delivery partner not avaiable') {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: `Delivery Partner not available`, life: 3000 })
                }
                else {
                    // Update checkout status and partner ID using bulk API
                    const orderIds = eligibleOrders.map(order => order.id);
                    const stallIds = selectedStalls.map(stall => typeof stall === 'object' ? stall.id : stall);
                    
                    CustomAxios.post('orders/bulk_order_status_change/', {
                        order_ids: orderIds,
                        stall_ids: stallIds,
                        partner_id: partner.id,
                        status: newStatus
                    }).then((response) => {
                        toast.current.show({ 
                            severity: 'success', 
                            summary: 'Success', 
                            detail: `Successfully assigned delivery partner to ${eligibleOrders.length} orders`, 
                            life: 3000 
                        });
                        orderDate != null ? GetOrders(orderDate[0], orderDate[1]) : GetOrders(today)
                        dispatch(updatePartnerAssignModal(false));
                    }).catch((error) => {
                        console.error("🍽️ Error updating checkout status:", error);
                        toast.current.show({ 
                            severity: 'error', 
                            summary: 'Error', 
                            detail: 'Failed to update order status', 
                            life: 3000 
                        });
                    });
                }
            })
        } else {
        const response = await CustomAxiosDP.post('delivery_create/', { mobileno: delivery_partner.mobileno, delivery_mode: deliveryMode, delivery_status: "Pending", user_checkout_id: id }).then((response) => {
            console.log(response.status)
            console.log(response.data.message)

            if (response.data.message == 'delivery partner not avaiable') {
                toast.current.show({ severity: 'error', summary: 'Error', detail: `Delivery Partner not available`, life: 3000 })
            }
            else {
                // console.log('ram',id,newStatus,partner)
                handleStatusChange(id, newStatus, partner)
            }

        })
        }
    }
    console.log("delivey partner ---------------------", selectedDeliveryPartner)
    return (
        <Box>
            <Toast ref={toast} />
            <Modal
                open={deliveryPartnerModal}
                onClose={handleClosedeliveryPartnerModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ zIndex: 1300 }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: '90%', md: '294px' },
                        height: { xs: 'auto', md: '200px' },
                        backgroundColor: 'white',
                        borderRadius: 2,
                        paddingBottom: 2,
                    }}
                >
                    <Box sx={{ padding: "12px 24px", backgroundColor: "#EEEEEE", display: "flex", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>ASSIGN DELIVERY PARTNER</Typography>
                    </Box>
                    <Box sx={{ padding: "20px", display: "flex", flexDirection: "column" }}>
                        <Typography sx={{ fontSize: "14px", fontWeight: "400" }}>Search Partner</Typography>
                        <Select
                            labelId={`status-label-${orderDetails.id}`}
                            value={selectedDeliveryPartner?.id || ""}
                            onChange={(e) => {
                                const selected = deliveryPartners.find(p => p.id === e.target.value);
                                dispatch(updateselectedDeliveryPartner(selected)); // store full object
                            }}
                            sx={{ width: "100%", height: "32px" }}
                        >
                            {deliveryPartners.length > 0 ? deliveryPartners.map(user => (
                                <MenuItem key={user.id} value={user.id}>
                                    {user.username}
                                </MenuItem>
                            )) : <MenuItem>No partners Available</MenuItem>}
                        </Select>
                    </Box>
                    <Box sx={{ backgroundColor: "#EEEEEE", display: "flex", justifyContent: "flex-end", padding: "12px 24px", gap: "20px" }}>
                        <Button variant="outlined" sx={{ textTransform: "none", color: "black" }} onClick={handleClosedeliveryPartnerModal}>Close</Button>
                        <Button variant="contained" disabled={selectedDeliveryPartner === ""} sx={{ textTransform: "none" }} onClick={() => delivery_update(orderDetails.id, 'delivery_partner_assigned', selectedDeliveryPartner)}>
                            {loading ? <CircularProgress size="18px" sx={{ color: "white" }} /> : 'Assign'}
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>

    )
};


export const useGetBatchHistory = () => {
    const dispatch = useDispatch();
    const batchHistory = useSelector(state => state.inventory.batchHistory)
    const selectedBatch = useSelector(state => state.inventory.selectedBatchNo)
    const edit = useSelector(state => state.inventory.inventoryDetailsEdit)
    const hub = useSelector(state => state.user.selected_hub);

    // dispatch(updateLoadingProducts(true))

    const getBatchHistory = async () => {
        const selectedHubFromStorage = localStorage.getItem('selected_hub');
        let selectedHub;
        
        if (selectedHubFromStorage) {
            try {
                const parsed = JSON.parse(selectedHubFromStorage);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    selectedHub = parsed[0];
                } else {
                    selectedHub = parsed;
                }
            } catch (error) {
                selectedHub = selectedHubFromStorage;
            }
        }
        
        if (!selectedHub) {
            console.log('No hub selected for batch history');
            dispatch(updateBatchHistory([]));
            return;
        }
        
        console.log('Fetching batch history for hub:', selectedHub);
        
        try {
            const users = await CustomAxios.get(`batch_history/${selectedHub}/`, {
            }).then(res => {
                if (res.data.length > 0) {
                    const transformedData = res.data.map((item) => ({
                        ...item,
                        purchased_on: dayjs(item.purchased_on),
                        // batch_number:parseInt(item.batch_number),
                        details_id: parseInt(item.hub_name),
                        batch: item.batch.map((batchItem) => ({
                            ...batchItem,
                            expired_on: dayjs(batchItem.expired_on),
                            expire_alert: dayjs(batchItem.expire_alert),
                            product_id: batchItem.product.id,

                        })),
                    }));
                    console.log(transformedData)
                    const filtered = transformedData?.filter((item) => {
                        return item.batch_number === selectedBatch.batch_number
                    })
                    dispatch(updateBatchHistory(transformedData))
                    if (edit) {
                        dispatch(updateSelectedBatchNo(filtered[0]))
                    }
                }

            })
        }
        catch (error) {
            console.error("Error fetching orders:", error);
        }

    }
    return getBatchHistory;
};


export const OrderDetailsModal = () => {
    const dispatch = useDispatch();
    const toast = useRef(null);
    const [formData, setFormData] = useState([]);
    const inventoryDetailsEdit = useSelector(state => state.inventory.inventoryDetailsEdit)
    const inventoryDetails = useSelector(state => state.inventory.inventory_detail)
    const supervisors = useSelector(state => state.inventory.supervisors)
    const products = useSelector(state => state.products.products);
    const inventory = useSelector(state => state.inventory.inventory);
    const inventoryDetailsModal = useSelector(state => state.inventory.inventoryDetailsModal);
    const formatdate = useDateformate()
    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState({});
    const [checked, setChecked] = useState(false);
    const getInventeroryDetails = useGetInventoryDetails()
    const getBatchHistory = useGetBatchHistory()
    const [items, setItems] = useState([]);
    const selectedHub = useSelector(state => state.user.selected_hub)?.[0];

    const hubId = formData.details_id;

    const filteredProducts = useMemo(() => {
    return products?.filter((product) => {
        if (!product.capacitydetails) return false;
        const productHubs = Object.keys(product.capacitydetails).map(id => parseInt(id));
        return productHubs.includes(parseInt(hubId));
    });
    }, [products, hubId]);


    const handleSearch = (event) => {
        const query = event.query.toLowerCase();
        let filteredProducts = products.filter(product =>
            product.name.toLowerCase().includes(query)
        );

        setItems(filteredProducts);
    };

useEffect(() => {
    if (inventoryDetailsEdit) {
        if (inventoryDetails) {
            setFormData(inventoryDetails);
        }
    } else if (selectedHub) {
        const selectedHubObject = inventory.find(item => item.value === selectedHub);
        if (selectedHubObject) {
            setFormData({
                batch: [{
                    product_id: "",
                    available_units: "",
                    units: "",
                    total_units: "",
                    expired_on: null,
                    expire_alert: null,
                    bogo_enabled: false,
                    quantity: "",
                }],
                place: selectedHubObject.name,
                supervisor_ids: selectedHubObject.supervisors,
                details_id: selectedHubObject.value,
                purchased_on: null,
                supplier: '',
                invoice: '',
                batch_no: '',
            });
            dispatch(updateInventryHubsupervisors(
                supervisors
                    .filter(obj1 => selectedHubObject.supervisors.includes(obj1.value))
                    .map(obj => obj.name)
            ));
        }
    }
}, [inventoryDetails, inventoryDetailsEdit, selectedHub]);

    const handleClose = () => {
        dispatch(updateInventoryDetail({
            batch: [{
                product_id: "",
                available_units: "",
                units: "",
                total_units: "",
                expired_on: null,
                expire_alert: null,
                bogo_enabled: false,
                quantity: "",
            }
            ],
            place: "",
            supervisor_ids: [
                0
            ],
            details_id: '',
            purchased_on: null,
            supplier: '',
            invoice: '',
            batch_no: '',
        }));
        dispatch(updateinventoryDetailsEdit(false));
        dispatch(updateInventryHubsupervisors([]))
        dispatch(updateInventoryDetailsModal(false));
        setErrors({})
    };


    const handleAddItem = () => {
        //console.log(formData)
        setFormData({
            ...formData,
            batch: [...formData.batch, {
                product_id: "",
                available_units: "",
                units: "",
                total_units: "",
                expired_on: null,
                expire_alert: null,
                quantity: "",
                bogo_enabled: false,
            }
            ],
        });
    };
    const capacity = [
        { name: 'grams', value: 'gms' },
        { name: 'kilogram', value: 'kg' },
        { name: 'litre', value: 'ltr' },
        { name: 'box', value: 'box' },
        { name: 'cups', value: 'cups' },
        { name: 'ml', value: 'ml' },
        { name: 'pieces', value: 'pieces' },
        { name: 'bunch', value: 'bunch' },
        { name: 'packet', value: 'packet' },
        { name: 'bottle', value: 'bottle' },
        { name: 'offer', value: 'offer' },
    ];

    const handleRemoveItem = (index) => {
        const updatedCapacityDetails = formData.batch.filter((_, i) => i !== index);
        setFormData({ ...formData, batch: updatedCapacityDetails });
    };


    const handleChangeOffer = (event) => {
        setChecked(event.value);
    };

    const handleChange = (e, date) => {
        console.log(date)
        const filtered = inventory?.filter((item) => item.value == e.value)
        console.log(filtered[0], e)
        if (date == "date") {
            // const date = formatdate(e)
            setFormData({
                ...formData,
                "purchased_on": e,
            });
        }
        else if (e.target.name == 'details_id') {
            const { name, value, label } = e.target;
            console.log("=================", name, value)
            const commonNames = supervisors
                .filter(obj1 => filtered[0].supervisors.some(obj2 => obj1.value === obj2))
                .map(obj => obj.name);
            dispatch(updateInventryHubsupervisors(commonNames))
            setFormData({
                ...formData,
                place: filtered[0].name,
                [name]: value,
                supervisor_ids: filtered[0].supervisors,
            });

        } else {
            const { name, value, label } = e.target;

            setFormData({
                ...formData,
                [name]: value,
                ...filtered[0]
            });

            // if (name === 'total_units' || name === 'units') {
            //     calculateTotalUnits({
            //       ...formData,
            //       [name]: value, 
            //     });
            //   }

        }


    };

    const handleItemChange = (e, index, date) => {
        const updatedProducts = formData?.batch?.map((item, i) => {
            if (i === index) {
                // Handle product_id changes
                if (e.name === "product_id") {
                    const { name, value } = e.target || {};
                    return { ...item, [name]: value };
                }

                if (date === "expired_on" || date === "expire_alert") {
                    return { ...item, [date]: e }; // Use 'e' directly for these date fields
                }

                // Handle other changes
                const { name, value } = e.target || {};
                return { ...item, [name]: value };
            }
            return item;
        });

        setFormData({ ...formData, batch: updatedProducts });
    };

    const selectedCountryTemplate = (option, props) => {
        if (option) {
            return (
                <Box sx={{ display: "flex", gap: "10px" }}>
                    <Box component="img" alt={option.name} src={option.image} sx={{ width: '16px', height: "16px", objectFit: "cover" }} />
                    <Box>{option.name}</Box>
                </Box>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const countryOptionTemplate = (option) => {
        return (
            <Box sx={{ display: "flex", gap: "10px" }}>
                <Box component="img" alt={option.name} src={option.image} sx={{ width: '30px', height: "30px", objectFit: "cover" }} />
                <Box>{option.name}</Box>
            </Box>
        );
    };

    const handleEditInventoryDetails = async (id) => {
        try {
            setLoading(true)
            // await validationSchemaInventoryDetails.validate(formData, { abortEarly: false });
            setErrors({});
            const response = await CustomAxios.put(`inventory/details/update/${id}/`, formData, {
            }).then(res => {
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Inventory details Updated Successfully', life: 3000 });
                getInventeroryDetails()
                getBatchHistory()
                setLoading(false)
            }).catch(err => {
                if (err?.response?.data?.expired_on) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: err?.response?.data?.expired_on, life: 3000 });
                } else if (err?.response?.data?.expire_alert) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: err?.response?.data?.expire_alert, life: 3000 });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please provide all the mandatory fields', life: 3000 });
                }
                setLoading(false)
            });
        }
        catch (validationErrors) {
            if (validationErrors.name === "ValidationError") {
                const formErrors = {};
                validationErrors.inner.forEach((error) => {
                    formErrors[error.path] = error.message;
                });
                setErrors(formErrors);
                setLoading(false)
            }
        }
    }


    const offers = [
        { name: 'Active', value: true },
        { name: 'Inactive', value: false },
    ];

    const handleSaveInventoryDetails = async () => {
        try {
            setLoading(true)
            // await validationSchemaInventoryDetails.validate(formData, { abortEarly: false });
            setErrors({});
            const response = await CustomAxios.post(`inventory/details/create/`, formData, {
            }).then(res => {
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Inventory details Created Successfully', life: 3000 });
                getInventeroryDetails()
                getBatchHistory()
                setLoading(false)
            }).catch(err => {
                if (err?.response?.data?.expired_on) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: err?.response?.data?.expired_on, life: 3000 });
                } else if (err?.response?.data?.expire_alert) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: err?.response?.data?.expire_alert, life: 3000 });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please provide all the mandatory fields', life: 3000 });
                }

                setLoading(false)
            });
        }
        catch (validationErrors) {
            if (validationErrors.name === "ValidationError") {
                const formErrors = {};
                validationErrors.inner.forEach((error) => {
                    formErrors[error.path] = error.message;
                });
                setErrors(formErrors);
                setLoading(false)
            }
        }
    }
    console.log(formData)
    useEffect(() => {
        console.log(inventoryDetails)
        if (inventoryDetails && inventoryDetailsEdit) {
            const hasOffer = inventoryDetails?.batch?.some((inventory) => {
                console.log(inventory.bogo_enabled);
                return inventory.bogo_enabled === true;
            });
            setChecked(hasOffer);
        }
    }, [inventoryDetailsEdit])
    return (
        <Box>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Modal
                open={inventoryDetailsModal}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ zIndex: 1000 }}
            >
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%', maxWidth: checked ? "1100px" : "900px", height: "454px", backgroundColor: 'white', }}>
                    <Box sx={{ height: "46px important", padding: "12px 24px", backgroundColor: "#EEEEEE", display: "flex", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "14", fontWeight: "500", lineHeight: "22px" }}> {inventoryDetailsEdit ? 'Edit Inventory Detils' : 'Add Inventory Detils'}</Typography>
                    </Box>
                    <Box >
                        <Box sx={{ padding: "24px", display: "flex", gap: "16px", flexDirection: "column", height: "362px", overflowY: "auto" }}>
                            <Box sx={{ display: "flex", gap: "16px", flexDirection: "column" }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Hub<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                        <Dropdown  disabled={true}  value={formData.details_id} options={inventory} name="details_id" optionLabel="name" style={{ zIndex: "1000", height: "32px", width: "192px" }}
                                            placeholder="Select Hub" className="w-full md:w-14rem" checkmark={true} highlightOnSelect={false} />
                                        {errors.details_id && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.details_id}</Typography>}
                                    </Box>
                                    <Box className="card flex justify-content-center" style={{ position: "relative", width: "100px", display: "flex", gap: "10px", alignItems: "center" }}>
                                        {/* Dynamic ON/OFF Text */}
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Offers: </Typography>
                                        <span
                                            style={{
                                                position: "absolute",
                                                left: checked ? "33px" : "90px",
                                                top: "32px",
                                                transform: "translate(-50%, -50%)",
                                                fontSize: "10px",
                                                fontWeight: "500",
                                                color: "white",
                                                pointerEvents: "none",
                                                zIndex: 3000
                                            }}
                                        >
                                            {checked ? "ON" : "OFF"}
                                        </span>
                                        <InputSwitch checked={checked} onChange={handleChangeOffer} />
                                        {/* <Switch
                                    checked={checked}
                                    onChange={handleChangeOffer}
                                    sx={{
                                    "& .MuiSwitch-thumb": { backgroundColor: checked ? "white" : "white" },
                                    "& .MuiSwitch-track": { backgroundColor: checked ? "white" : "white" },
                                    width:"55px"
                                    }}
                                /> */}
                                    </Box>
                                </Box>

                                <Box sx={{ display: "flex", gap: "16px" }}>
                                    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Batch #</Typography>
                                        <InputBase disabled={true} value={formData.batch_number} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Batch no" name="batch_no" onChange={(e) => handleChange(e)} />
                                    </Box>
                                    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Purchased on<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                value={formData.purchased_on}
                                                onChange={(e) => handleChange(e, "date")}
                                                className="pan-datepicker background"
                                                renderInput={(params) => <TextField {...params} sx={{ fontSize: "14px", }} placeholder="DD/MM/YY" />}
                                                name="purchased_on"
                                                sx={{
                                                    pading: 0,
                                                    "&.pan-datepicker .MuiInputBase-root.MuiOutlinedInput-root": {
                                                        height: '32px',
                                                        padding: '0 8px',
                                                        border: "none",
                                                        width: "100%",
                                                        backgroundColor: "#FFF",
                                                        zIndex: 2
                                                    },
                                                    "&.MuiPaper-root-MuiPickersPopper-paper": {
                                                        backgroundColor: "#FFF"
                                                    },
                                                    "& .MuiPaper-root": {
                                                        backgroundColor: "#FFF",
                                                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                                        borderRadius: '8px',
                                                    },

                                                }}
                                            />
                                        </LocalizationProvider>

                                    </Box>
                                    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px", display: "inline-block" }}>Supplier <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px", color: "text.optional", display: "inline-block" }}>(optional)</Typography></Typography>
                                        <InputBase value={formData.supplier} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Supplier" name="supplier" onChange={(e) => handleChange(e)} />
                                    </Box>
                                    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Invoice #  <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px", color: "text.optional", display: "inline-block" }}>(optional)</Typography></Typography>
                                        <InputBase value={formData.invoice} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Invoice" name="invoice" onChange={(e) => handleChange(e)} />
                                    </Box>
                                </Box>
                                {formData?.batch?.map((item, index) => (
                                    <Box sx={{ width: "100%", display: "flex", gap: "16px", alignItems: "flex-end" }}>
                                        <Box sx={{ minWidth: "192px", display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Products<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                            <Dropdown onChange={(e) => handleItemChange(e, index)} value={item.product_id} options={filteredProducts} name="product_id" optionLabel="name" style={{ zIndex: "1000", height: "32px" }}
                                                placeholder="Select Product" className="w-full md:w-14rem"
                                                valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate}
                                                filter filterBy="name"
                                            />
                                            {/* <AutoComplete
                                                onChange={(e) => handleItemChange(e, index)} 
                                                value={items.find(product => product.id === item.product_id)} 
                                                suggestions={items}
                                                completeMethod={handleSearch} 
                                                field="name"  
                                                name="product_id"
                                                placeholder="Select Product"
                                                style={{ zIndex: "1000", height: "32px" }}
                                                className="w-full md:w-14rem"
                                                valueTemplate="sri"
                                                itemTemplate={countryOptionTemplate}
                                                dropdown 
                                                dropdownMode="blank" 
                                            /> */}
                                            {errors.product_id && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.product_id}</Typography>}
                                        </Box>
                                        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Quantity<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                            <InputBase value={item.quantity} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Quantity" name="quantity" onChange={(e) => handleItemChange(e, index)} />
                                            {errors.quantity && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.quantity}</Typography>}
                                        </Box>
                                        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Units<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                            <Dropdown value={item.units} onChange={(e) => handleItemChange(e, index)} options={capacity} optionLabel="name" name="units" style={{ zIndex: "1000", height: "32px" }}
                                                placeholder="Select units" className="w-full md:w-14rem" checkmark={true} highlightOnSelect={false} />
                                            {errors.units && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.units}</Typography>}
                                        </Box>
                                        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Expired<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={item.expired_on}
                                                    onChange={(e) => handleItemChange(e, index, "expired_on")}
                                                    className="pan-datepicker background"
                                                    renderInput={(params) => <TextField {...params} style={{ padding: "0" }} />}
                                                    name="expired_on"
                                                    sx={{
                                                        "&.pan-datepicker .MuiInputBase-root.MuiOutlinedInput-root": {
                                                            height: '32px',
                                                            padding: '0 8px',
                                                            border: "none",
                                                            width: "100%",
                                                            backgroundColor: "#FFF",
                                                            zIndex: 2
                                                        },
                                                        "&.MuiPaper-root-MuiPickersPopper-paper": {
                                                            backgroundColor: "#FFF"
                                                        },
                                                        "& .MuiPaper-root": {
                                                            backgroundColor: "#FFF",
                                                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                                            borderRadius: '8px',
                                                        },

                                                    }}
                                                />
                                            </LocalizationProvider>
                                            {errors.expired && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.expired}</Typography>}
                                        </Box>
                                        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Set expire alert<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={item.expire_alert}
                                                    onChange={(e) => handleItemChange(e, index, "expire_alert")}
                                                    className="pan-datepicker background"
                                                    renderInput={(params) => <TextField {...params} />}
                                                    name="expire_alert"
                                                    sx={{
                                                        "&.pan-datepicker .MuiInputBase-root.MuiOutlinedInput-root": {
                                                            height: '32px',
                                                            padding: '0 8px',
                                                            border: "none",
                                                            width: "100%",
                                                            backgroundColor: "#FFF",
                                                            zIndex: 2
                                                        },
                                                        "&.MuiPaper-root-MuiPickersPopper-paper": {
                                                            backgroundColor: "#FFF"
                                                        },
                                                        "& .MuiPaper-root": {
                                                            backgroundColor: "#FFF",
                                                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                                            borderRadius: '8px',
                                                        },

                                                    }}
                                                />
                                            </LocalizationProvider>
                                            {errors.Set_expire_alert && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.Set_expire_alert}</Typography>}
                                        </Box>
                                        {checked && <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Offers</Typography>
                                            <Dropdown onChange={(e) => handleItemChange(e, index)} value={item.bogo_enabled} options={offers} name="bogo_enabled" optionLabel="name" style={{ zIndex: "1000", height: "32px" }}
                                                placeholder="Bogo status" className="w-full md:w-14rem"

                                            />
                                            {errors.product_id && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.product_id}</Typography>}
                                        </Box>}
                                        <Tooltip title="Remove" arrow>
                                            <IconButton sx={{ height: "14px", width: "14px", color: "primary.button", marginBottom: "10px" }} type="button" onClick={() => handleRemoveItem(index)}>
                                                <CancelOutlinedIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>))}
                                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                    <Button variant="outlined" sx={{ border: "2px dotted", borderColor: "secondary.border", width: "100%" }} onClick={handleAddItem}><Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} >Add Item</Typography></Button>
                                </Box>

                            </Box>
                        </Box>

                    </Box>
                    <Box sx={{ backgroundColor: "#EEEEEE", display: "flex", alignItems: "center", position: "absolute", bottom: 0, display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        <Box sx={{ padding: "12px 24px", display: "flex", gap: "20px" }}>
                            <Button variant="outlined" sx={{ textTransform: "none", color: "black", backgroundColor: "white", height: "32px", width: "67px" }} onClick={handleClose}> cancel</Button>
                            <Button variant="contained" sx={{ textTransform: "none", height: "32px", width: "67px" }} onClick={() => inventoryDetailsEdit ? handleEditInventoryDetails(formData.id) : handleSaveInventoryDetails()} > {inventoryDetailsEdit ? loading ? <CircularProgress size="25px" sx={{ color: "white" }} /> : 'Update' : loading ? <CircularProgress size="25px" sx={{ color: "white" }} /> : 'Save'}</Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </Box>

    )
}

export const useGetOffers = () => {
    const dispatch = useDispatch();
    const today = dayjs()
    const formatdate = useDateformate()
    const hub = useSelector(state => state.user.selected_hub);
    const getOffers = async () => {
      dispatch(updateOfferLoading(true))
      try {
        /*
         * No hub, nothing to ask for.
         *
         * `selected_hub` starts as null and the header calls this from a mount
         * effect, so the first run always lands here. The request was already
         * skipped in that case -- but `response` was then read anyway, one line
         * below, and threw "Cannot read properties of undefined (reading
         * 'data')" into the catch on every page load.
         *
         * Returning leaves the offers already in the store alone, which is what
         * the throw effectively did; the only thing that changes is the error.
         * The commented-out branch below is the unfiltered `offers/` call this
         * replaced -- left as-is, since fetching every hub's offers is not
         * wanted here.
         */
        if (!(hub > 0)) {
          dispatch(updateOfferLoading(false))
          return
        }

        const response = await CustomAxios.get(`offers/${hub}/`);
        // else{
        //     response = await CustomAxios.get(`offers/`);
        // }

        dispatch(updateOffers(response.data))
        dispatch(updateOfferLoading(false))
  
      } catch (error) {
        console.error("Error fetching orders:", error);
        dispatch(updateOfferLoading(false))
      }
    };
  
    return getOffers;
  };


export const useUpdateDeliverySettings = () => {
    const dispatch = useDispatch();


    const getDeliverySettings = async () => {
        try {
            const response = await CustomAxios.get(`delivery_settings/`);
            dispatch(updateSettings(response.data))
            console.log(response.data)

        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    };

    return getDeliverySettings;
};


export const useGetProductBanners = () => {
    const dispatch = useDispatch();

    const getProductBannerDetails = async () => {
        const selectedHubRaw = localStorage.getItem("selected_hub");
        const userRole = localStorage.getItem('role');
        
        let selectedHub;
        try {
            const parsedHub = JSON.parse(selectedHubRaw || '[]');
            
            if (userRole === 'super_admin') {
                selectedHub = 'all'; 
            } else if (Array.isArray(parsedHub) && parsedHub.length > 0) {
                selectedHub = parsedHub.join(',');
            } else {
                selectedHub = parsedHub;
            }
        } catch (error) {
            selectedHub = selectedHubRaw;
        }

        try {
            const response = await CustomAxios.get(`product_banner/?hub_id=${selectedHub}`);
            const options = response?.data?.map((item) => ({
                name: item.name,
                content: item.content,
                status: item.status,
                ...item
            }));
            console.log('optionssssss--->>',options)
            dispatch(updateProductBanners(options));
        } catch (error) {
            console.error("Error fetching product banners:", error);
        }
    };

    return getProductBannerDetails;
};

export const useGetHomeBanners = () => {
    const dispatch = useDispatch();

    const getHomeBannerDetails = async () => {
        const selectedHubRaw = localStorage.getItem("selected_hub");
        const userRole = localStorage.getItem('role');
        
        let selectedHub;
        try {
            const parsedHub = JSON.parse(selectedHubRaw || '[]');
            
            if (userRole === 'super_admin') {
                selectedHub = 'all';
            } else if (Array.isArray(parsedHub) && parsedHub.length > 0) {
                selectedHub = parsedHub.join(',');
            } else {
                selectedHub = parsedHub;
            }
        } catch (error) {
            selectedHub = selectedHubRaw;
        }

        try {
            const response = await CustomAxios.get(`home_banner/?hub_id=${selectedHub}`);
            const options = response?.data?.map((item) => ({
                name: item.name,
                content: item.content,
                status: item.status,
                ...item
            }));
            console.log('optionssssss--->>', options)
            dispatch(updateHomeBanners(options)); 
        } catch (error) {
            console.error("Error fetching home banners:", error);
        }
    };

    return getHomeBannerDetails;
};

const hub = (() => {
    try {
        const hubData = localStorage.getItem("selected_hub");
        if (!hubData || hubData === "") {
            return [];
        }
        return JSON.parse(hubData);
    } catch (error) {
        console.error("Error parsing selected_hub from localStorage:", error);
        return [];
    }
})();